module.exports = __webpack_public_path__ + "img/Real-Ireland-logo[Mono].78b5eec9.png";